// extracted by mini-css-extract-plugin
module.exports = {"version-tip":"RdrHJr9BaXTGDTIgyP18Kg==","warning-img":"-Gg8PemFZMYY+e2vmF9Uaw==","create-version":"VHzd2m3xLcN8ArxES+2T1g=="};